import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AxpoLogoComponent } from './axpo-logo/axpo-logo.component';
import { ProfileDropdownComponent } from './profile-dropdown/profile-dropdown.component';

@Component({
  selector: 'app-header',
  imports: [AxpoLogoComponent, ProfileDropdownComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {}
